import { service } from "../pages/needHelp/utils";

const getKey = (bookingId) => `TIMER_${bookingId}`;

export const updateTimer = (bookingId) => {
  try {
    const timer = localStorage.getItem(getKey(bookingId));
    if (!timer) {
      const time = Date.now();
      localStorage.setItem(getKey(bookingId), JSON.stringify(time));
    }
  } catch (error) {
    console.error("Error while updating timer");
  }
};

export const getLatestTimer = () => {
  try {
    const bookingId = service.getMmtId();
    const time = localStorage.getItem(getKey(bookingId));
    if (time) {
      const storedTime = JSON.parse(time);
      return {
        success: true,
        time: storedTime
      }
    }
    throw new Error("Time has not been set yet.")
  } catch (error) {
    console.trace("Error while fetching timer", error.message);
    return {
      success: false,
      time: Date.now()
    }
  }
};
